// @flow

import React, { Component } from 'react';
import t from '~/src/services/i18n';
import routes, { assetUrl } from '~/src/config/routes.js';
import trackEvent from '~/src/services/analytics';
import './PageIntro.scss';

type Props = {
  page: string,
}

const content = {
  product: {title: 'productGallery', image: 'intro-product'},
  events: {title: 'eventsAndAnalytics', image: 'intro-events'},
  transformation: {title: 'urlTransformation', image: 'intro-url'},
};

const linksForEventTracking = {
  'relevant events': 'product gallery events',
  'image': 'image transformations',
  'video': 'video transformations',
  'replace_color': 'image transformations',
};

class PageIntro extends Component<Props> {
  render() {
    return (
      <div className="page-intro">
        <div className="intro-content">
          <h2>{t(content[this.props.page].title)}</h2>
          <p
            onClick={(e) => {
              if (e.target.tagName == 'A') {
                trackEvent({
                  action: 'learn more',
                  label: 'clicked on ' + e.target.innerText + ' to learn more about ' + (linksForEventTracking[e.target.innerText] || e.target.innerText)
                });
              }
            }}
          >{t('pageIntroText.' + this.props.page)}</p>
          <a
            href={routes.learnMore[this.props.page]}
            target="_blank"
            className="docs-link"
            onClick={() => trackEvent({
              action: t('learnMore', {}),
              label: 'clicked on ' + t('learnMore', {}) + ' to learn more about product gallery'
            })}
          >
            {t('learnMore')}
          </a>
        </div>
        <img src={assetUrl(content[this.props.page].image)} />
      </div>
    );
  }
}

export default PageIntro;
